"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maintainScrollVisibility = exports.isScrollable = exports.getUpdatedIndex = exports.getActionFromKey = exports.filterOptions = exports.MenuActions = exports.Keys = void 0;
var Keys;
(function (Keys) {
    Keys["Backspace"] = "Backspace";
    Keys["Clear"] = "Clear";
    Keys["Down"] = "ArrowDown";
    Keys["End"] = "End";
    Keys["Enter"] = "Enter";
    Keys["Escape"] = "Escape";
    Keys["Home"] = "Home";
    Keys["Left"] = "ArrowLeft";
    Keys["PageDown"] = "PageDown";
    Keys["PageUp"] = "PageUp";
    Keys["Right"] = "ArrowRight";
    Keys["Space"] = " ";
    Keys["Tab"] = "Tab";
    Keys["Up"] = "ArrowUp";
})(Keys = exports.Keys || (exports.Keys = {}));
var MenuActions;
(function (MenuActions) {
    MenuActions[MenuActions["Close"] = 0] = "Close";
    MenuActions[MenuActions["CloseSelect"] = 1] = "CloseSelect";
    MenuActions[MenuActions["First"] = 2] = "First";
    MenuActions[MenuActions["Last"] = 3] = "Last";
    MenuActions[MenuActions["Next"] = 4] = "Next";
    MenuActions[MenuActions["Open"] = 5] = "Open";
    MenuActions[MenuActions["PageDown"] = 6] = "PageDown";
    MenuActions[MenuActions["PageUp"] = 7] = "PageUp";
    MenuActions[MenuActions["Previous"] = 8] = "Previous";
    MenuActions[MenuActions["Select"] = 9] = "Select";
    MenuActions[MenuActions["Space"] = 10] = "Space";
    MenuActions[MenuActions["Type"] = 11] = "Type";
})(MenuActions = exports.MenuActions || (exports.MenuActions = {}));
// filter an array of options against an input string
// returns an array of options that begin with the filter string, case-independent
function filterOptions(options = [], filter, exclude = []) {
    let filterString = (filter !== null && filter !== void 0 ? filter : "").toLowerCase().trim().split(" ");
    return options
        .map((option) => {
        var _a;
        return (Object.assign(Object.assign({}, option), { services: (_a = option.services) === null || _a === void 0 ? void 0 : _a.filter((service) => {
                const matches = filterString.every((filterWord) => { var _a; return ((_a = service.name) !== null && _a !== void 0 ? _a : "").toLowerCase().indexOf(filterWord) >= 0; });
                return matches && exclude.indexOf(service) < 0;
            }) }));
    })
        .filter((option) => option.services && option.services.length > 0);
}
exports.filterOptions = filterOptions;
function getActionFromKey(event, menuOpen) {
    const { key, altKey, ctrlKey, metaKey } = event;
    const openKeys = [
        Keys.Down,
        Keys.Up,
        Keys.Enter,
        Keys.Space,
        Keys.Home,
        Keys.End,
    ]; // all keys that will open the combo
    // handle opening when closed
    if (!menuOpen && openKeys.some((k) => k === key)) {
        return MenuActions.Open;
    }
    // handle typing characters when open or closed
    if (key === Keys.Backspace ||
        key === Keys.Clear ||
        (key.length === 1 && key !== " " && !altKey && !ctrlKey && !metaKey)) {
        return MenuActions.Type;
    }
    // handle keys when open
    if (menuOpen) {
        if ((key === Keys.Down && !altKey) || key === Keys.Right) {
            return MenuActions.Next;
        }
        else if (key === Keys.Up && altKey) {
            return MenuActions.CloseSelect;
        }
        else if (key === Keys.Up || key === Keys.Left) {
            return MenuActions.Previous;
        }
        else if (key === Keys.Home) {
            return MenuActions.First;
        }
        else if (key === Keys.End) {
            return MenuActions.Last;
        }
        else if (key === Keys.PageUp) {
            return MenuActions.PageUp;
        }
        else if (key === Keys.PageDown) {
            return MenuActions.PageDown;
        }
        else if (key === Keys.Escape) {
            return MenuActions.Close;
        }
        else if (key === Keys.Enter) {
            return MenuActions.CloseSelect;
        }
        else if (key === Keys.Space) {
            return MenuActions.Space;
        }
    }
}
exports.getActionFromKey = getActionFromKey;
// get updated option index
function getUpdatedIndex(current, max, action) {
    switch (action) {
        case MenuActions.First:
            return 0;
        case MenuActions.Last:
            return max;
        case MenuActions.Previous:
            return Math.max(0, current - 1);
        case MenuActions.Next:
            return Math.min(max, current + 1);
        default:
            return current;
    }
}
exports.getUpdatedIndex = getUpdatedIndex;
// check if an element is currently scrollable
function isScrollable(element) {
    return element.current ? element.current.clientHeight < element.current.scrollHeight : false;
}
exports.isScrollable = isScrollable;
// ensure given child element is within the parent's visible scroll area
function maintainScrollVisibility(activeElement, scrollParent) {
    if (!activeElement.current || !scrollParent.current) {
        return;
    }
    const { offsetHeight, offsetTop } = activeElement.current;
    const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent.current;
    const isAbove = offsetTop < scrollTop;
    const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
    if (isAbove) {
        const maybeStrong = activeElement.current.previousElementSibling;
        if ((maybeStrong === null || maybeStrong === void 0 ? void 0 : maybeStrong.tagName) === "STRONG") {
            scrollParent.current.scrollTo(0, maybeStrong.offsetTop);
        }
        else {
            scrollParent.current.scrollTo(0, offsetTop);
        }
    }
    else if (isBelow) {
        scrollParent.current.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
    }
}
exports.maintainScrollVisibility = maintainScrollVisibility;
